<template>
  <div>
    <h2 style="margin-bottom: 16px;">{{ id ? '编辑' : '创建' }}活动</h2>
    <el-tabs type="border-card">
      <el-tab-pane label="活动编辑">
        <el-form :model="form" label-width="110px" style="max-width: 720px;" :rules="rules" ref="form">
          <el-form-item label="活动名称" prop="activity_title">
            <el-input v-model="form.activity_title"></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker v-model="form.activity_statetime" type="datetime" value-format="timestamp" placeholder="选择开始时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="form.activity_endtime" type="datetime" value-format="timestamp" placeholder="选择结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="地点">
            <el-input v-model="form.activity_locale"></el-input>
          </el-form-item>
          <el-form-item label="人数限制">
            <el-switch v-model="form.activity_impose"></el-switch>
          </el-form-item>
          <el-form-item label="活动人数" prop="activity_num">
            <el-input v-model="form.activity_num"></el-input>
          </el-form-item>
          <el-form-item label="活动分类">
            <el-radio-group v-model="form.activity_lable">
              <el-radio v-for="item in lable" :key="item" :label="item">{{ item }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式">
            <el-radio-group v-model="form.activity_type">
              <el-radio label="线上">线上</el-radio>
              <el-radio label="线下">线下</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="内容介绍">
            <rich-editor v-model="form.activity_content"></rich-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定</el-button>
            <el-button @click="$router.push('/admin/createactivitylist')">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="公告管理">
        <p v-if="!id" style="color: #999; padding: 10px 0;">请先添加活动，活动添加成功后才可以添加活动公告</p>
        <template v-else>
          <el-button type="text" icon="el-icon-plus" @click="dialogVisible = true">添加新的活动公告</el-button>
          <el-timeline style="margin-top: 16px;">
            <el-timeline-item v-for="item in announcementlist" :key="item.announcement_id" :timestamp="item.announcement_createtime | dataFormat">
              <el-card shadow="never">
                <p style="font-weight: bold;">{{ item.announcement_name }}</p>
                <p style="font-size: 13px; color: #666; margin-top: 6px;">{{ item.announcement_content }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </template>
      </el-tab-pane>
      <el-tab-pane label="活动人员管理">
        <el-table :data="joinslist" border>
          <el-table-column label="报名日期" width="170">
            <template slot-scope="scope">{{ scope.row.jions_createtime | dataFormat }}</template>
          </el-table-column>
          <el-table-column label="账号" prop="username"></el-table-column>
          <el-table-column label="昵称" prop="nickname"></el-table-column>
          <el-table-column label="qq" prop="qq"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="发布公告" :visible.sync="dialogVisible" width="30%">
      <el-form label-width="80px">
        <el-form-item label="公告名称">
          <el-input v-model="announcement.announcement_name"></el-input>
        </el-form-item>
        <el-form-item label="公告内容">
          <el-input type="textarea" :rows="5" v-model="announcement.announcement_content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="setannouncement">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import richEditor from '@/components/editor.vue'
import { getLable, createActivity, updateActivity, getActivityDetails, getMyJoins, setAnnouncement, getAnnouncementList } from '@/api'

export default {
  name: 'CreateActivity',
  components: { richEditor },
  props: { id: { type: String, default: '' } },
  data() {
    return {
      lable: [],
      dialogVisible: false,
      joinslist: [],
      announcementlist: [],
      announcement: { announcement_name: '', announcement_content: '' },
      rules: {
        activity_title: [{ required: true, message: '活动名称不能为空', trigger: 'blur' }],
        activity_num: [
          { required: true, message: '人数不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: '人数必须为数字值', trigger: 'blur' }
        ]
      },
      form: {
        activity_title: '', activity_statetime: null, activity_endtime: null, activity_locale: '',
        activity_impose: false, activity_num: 0, activity_lable: '', activity_type: '线下', activity_content: ''
      }
    }
  },
  created() {
    getLable('活动分类').then((res) => {
      this.lable = JSON.parse(res.data[0].lable) || []
    })
    if (this.id) {
      getActivityDetails(this.id).then((res) => {
        const d = res.data || {}
        this.form = {
          activity_title: d.activity_title, activity_statetime: d.activity_statetime, activity_endtime: d.activity_endtime,
          activity_locale: d.activity_locale, activity_impose: d.activity_impose, activity_num: d.activity_num,
          activity_lable: d.activity_lable, activity_type: d.activity_type, activity_content: d.activity_content
        }
      })
      getMyJoins(this.id).then((res) => {
        this.joinslist = res.data || []
      })
      getAnnouncementList(this.id).then((res) => {
        this.announcementlist = res.data || []
      })
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (this.id) {
          updateActivity({ ...this.form, id: this.id }).then((res) => {
            if (res.state.type === 'SUCCESS') {
              this.$message.success('修改成功')
              this.$router.push('/admin/createactivitylist')
            }
          })
        } else {
          createActivity(this.form).then((res) => {
            if (res.state.type === 'SUCCESS') {
              this.$message.success('发布成功，等待审核')
              this.$router.push('/admin/createactivitylist')
            }
          })
        }
      })
    },
    setannouncement() {
      if (!this.announcement.announcement_name || !this.announcement.announcement_content) {
        this.$message.error('请填写完整')
        return
      }
      setAnnouncement({ contentname: this.form.activity_title, content_id: this.id, type: 'activity', ...this.announcement }).then(() => {
        this.$message.success('公告发布成功')
        this.dialogVisible = false
        this.announcement = { announcement_name: '', announcement_content: '' }
        getAnnouncementList(this.id).then((res) => {
          this.announcementlist = res.data || []
        })
      })
    }
  }
}
</script>
